import { render, staticRenderFns } from "./SynologyDownload.vue?vue&type=template&id=4ff1ccd8&scoped=true&"
import script from "./SynologyDownload.vue?vue&type=script&lang=js&"
export * from "./SynologyDownload.vue?vue&type=script&lang=js&"
import style0 from "./SynologyDownload.vue?vue&type=style&index=0&id=4ff1ccd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff1ccd8",
  null
  
)

export default component.exports